import { useApplyBillCredit } from "@/api/queries";
import type { Bill, SupplierCredit } from "@/api/types";
import { UseCreditDialog as CreditDialog } from "@/components/UseCreditDialog";
import { formatAmount } from "@/lib/money";

/** Uses an advance or a no-bill debit note against this bill. */
export function UseCreditDialog({
  bill,
  credits,
  onClose,
}: {
  bill: Bill;
  credits: SupplierCredit[];
  onClose: () => void;
}) {
  const apply = useApplyBillCredit(bill.id);
  return (
    <CreditDialog
      documentNumber={bill.number}
      documentLabel="bill"
      description={`${bill.supplierName} is owed ${formatAmount(bill.balance)} on this bill.`}
      balance={bill.balance}
      credits={credits.map((credit) => ({
        ...credit,
        kindLabel: credit.kind === "advance" ? "advance" : "debit note",
      }))}
      pending={apply.isPending}
      error={apply.error}
      onUse={(sourceId, amount) =>
        apply.mutate(
          { kind: credits.find((c) => c.sourceId === sourceId)!.kind, sourceId, amount },
          { onSuccess: onClose },
        )
      }
      onClose={onClose}
    />
  );
}
